"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebar = exports.SidebarContext = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var hooks_1 = require("@nef/hooks");
var Flex_1 = __importDefault(require("../Flex"));
var SidebarBody_1 = require("../SidebarBody");
exports.SidebarContext = react_1.default.createContext({
    expanded: false,
    rtl: false
});
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var expanded = _a.expanded, toggleSidebar = _a.toggleSidebar, rtl = _a.rtl, props = __rest(_a, ["expanded", "toggleSidebar", "rtl"]);
    return react_1.default.createElement(Flex_1.default, __assign({ ref: ref }, props));
});
innerFunction.displayName = "innerFunction";
exports.StyledSidebar = styled_components_1.default(innerFunction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-shadow: ", ";\n  ", ";\n  ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: ", ";\n  height: 100vh;\n  width: 50px;\n  z-index: 1030;\n\n  ", "\n\n  .sidebar-top {\n    background-color: ", ";\n  }\n\n  ", " {\n    padding: 0.571rem 0;\n  }\n"], ["\n  box-shadow: ", ";\n  ",
    ";\n  ",
    ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: ", ";\n  height: 100vh;\n  width: 50px;\n  z-index: 1030;\n\n  ",
    "\n\n  .sidebar-top {\n    background-color: ", ";\n  }\n\n  ", " {\n    padding: 0.571rem 0;\n  }\n"])), style_utils_1.getShadow(4), function (props) {
    return !props.rtl && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      left: 0;\n    "], ["\n      left: 0;\n    "])));
}, function (props) {
    return props.rtl && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      right: 0;\n    "], ["\n      right: 0;\n    "])));
}, style_utils_1.getSidebarColor(0), function (props) {
    return props.expanded && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 257px;\n    "], ["\n      width: 257px;\n    "])));
}, style_utils_1.getSidebarColor(0), SidebarBody_1.StyledSidebarBody);
var Sidebar = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var context = react_1.default.useContext(exports.SidebarContext);
    var sidebarRef = react_1.default.useRef();
    var handleKeyDown = function (e) {
        var _a, _b, _c, _d, _e;
        var focusableElements = hooks_1.getAllFocusableChildElements(sidebarRef === null || sidebarRef === void 0 ? void 0 : sidebarRef.current).filter(function (el) {
            return !el.classList.contains("sidebar--popover-button") &&
                !el.classList.contains("sidebar--app-selector--popover--button");
        });
        var length = focusableElements.length;
        var idx = focusableElements.findIndex(function (el) { return el === document.activeElement; });
        if (e.target.classList.contains("sidebar--popover-button") ||
            e.target.classList.contains("sidebar--app-selector--popover--button")) {
            e.preventDefault();
            e.stopPropagation();
            if (e.key === "Escape" ||
                e.key === "Esc" ||
                e.key === "ArrowLeft" ||
                (e.key === "ArrowUp" &&
                    ((_a = e.target.previousElementSibling) === null || _a === void 0 ? void 0 : _a.tagName) !== "BUTTON") ||
                (e.key === "ArrowDown" && !e.target.nextElementSibling)) {
                (_d = (_c = (_b = e.target.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.previousElementSibling) === null || _d === void 0 ? void 0 : _d.focus();
            }
        }
        else if (e.key.includes("Arrow")) {
            e.preventDefault();
            e.stopPropagation();
            if (idx !== -1) {
                switch (e.key) {
                    case "ArrowUp":
                        idx -= 1;
                        break;
                    case "ArrowDown":
                        idx += 1;
                        break;
                    case "ArrowLeft":
                        idx -= 1;
                        break;
                    case "ArrowRight":
                        setTimeout(function () {
                            var _a;
                            (_a = hooks_1.getFocusableElement(focusableElements[idx].nextElementSibling)) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 10);
                        break;
                    default:
                        break;
                }
            }
            if (idx < 0) {
                idx = 0;
            }
            if (idx > length - 1) {
                idx = length - 1;
            }
            (_e = focusableElements[idx]) === null || _e === void 0 ? void 0 : _e.focus();
        }
    };
    return (react_1.default.createElement(exports.StyledSidebar, __assign({}, props, context, { className: style_utils_1.classNames("sidebar", className), onKeyDown: handleKeyDown, flexDirection: "column", ref: sidebarRef })));
};
exports.default = Sidebar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map